import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const WirelessConnectivity = ({ onWirelessConnectivitySelected }) => {
  const [selectedWirelessConnectivity, setSelectedWirelessConnectivity] =
    useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.wirelessconnectivity) {
        const wirelessConnectivityObject = firstResult.wirelessconnectivity;
        if (wirelessConnectivityObject.trim() !== "") {
          setVariations(wirelessConnectivityObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handleWirelessConnectivityClick = (wirelessconnectivity) => {
    setSelectedWirelessConnectivity(wirelessconnectivity);
    onWirelessConnectivitySelected(wirelessconnectivity);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Wireless Connectivity:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedWirelessConnectivity === variation ? "selected" : ""}`}
            onClick={() => handleWirelessConnectivityClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default WirelessConnectivity;
